module.exports = __webpack_public_path__ + "img/iphone2.b6203103.png";